import Vue from "vue";

export class Repetidor {
    static create() {
        return {
            ssh: {
                host: null,
                username: null,
                password: null,
                readyTimeout: 5000,
                algorithms: {
                    serverHostKey: ["ssh-rsa", "ssh-dss"]
                }
            },
            geocode: {
                latitude: 0,
                longitude: 0
            },
            radius: 1000,
            nome: null
        };
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static byID(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("repetidor/" + id)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static excluir(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .delete("repetidor/" + id)
                .then(() => resolve(), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static all() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("repetidores")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param data
     * @return {Promise}
     */
    static save(data) {
        return new Promise((resolve, reject) => {
            let promisse = null;

            if (data._id) {
                promisse = Vue.http.put("repetidores", data);
            } else {
                promisse = Vue.http.post("repetidores", data);
            }

            promisse.then(() => resolve(), err => reject(err));
        });
    }
}
